<div class="cw-button-wrapper buttons">
    <button mat-raised-button color="accent" [disabled]="!settingsEnabled" (click)="showSettings()">
        {{ 'GENERAL.SETTINGS' | translate }}
    </button>
    <button mat-raised-button color="accent" (click)="clickRefresh()">
        {{ 'GENERAL.RELOADDATA' | translate }}
    </button>
    <button mat-raised-button color="accent" (click)="clickLogout()">
        {{ 'GENERAL.LOGOUT' | translate }}
    </button>
</div>
